interface PaymentDetailItemProps {
  label: string;
  children: React.ReactNode;
}

export default function PaymentDetailsItem({
  label,
  children,
}: PaymentDetailItemProps) {
  return (
    <div className="flex flex-row justify-between items-center">
      <div className="text-sm font-medium text-gray-300">{label}</div>
      <div className="text-sm text-right flex items-center gap-2">
        {children}
      </div>
    </div>
  )
}
